import ApiUtil from '../utils/ApiUtil';
import { configurationServiceUrls } from 'constants/apiEndPoints';

export const getAllActiveConfiguration = async (): Promise<unknown> => await
    new Promise((resolve, reject) => {
        ApiUtil.getWithToken(configurationServiceUrls.getConfig)
            .then((result) => {
                resolve(result);
            }).catch((error) => { reject(error); })
    });


export const updateActiveConfiguration = async (id: number, data: unknown): Promise<unknown> => await
    new Promise((resolve, reject) => {
        ApiUtil.putWithToken(`${configurationServiceUrls.updateConfig}/${id}`, data)
            .then((result) => {
                resolve(result);
            }).catch((error) => { reject(error); })
    });